/* IZECOmfort v9 · Un solo botón de contrarreembolso que abre EasySell, formulario en azul con logo y reseñas compactas */
(function(){
'use strict';
var d=document;
function $(s,r){return (r||d).querySelector(s);}
function esBtn(){return d.getElementById('es-popup-button');}
function money(c){c=Math.round(+c||0);return '€'+(c/100).toFixed(2).replace('.',',');}
function imp(el,p,v){if(!el)return;var k=el._izc||(el._izc={});if(k[p]!==undefined&&k[p]===el.style.getPropertyValue(p))return;el.style.setProperty(p,v,'important');k[p]=el.style.getPropertyValue(p);}

/* 1. Nuestro botón azul (y la barra fija) abren el formulario de EasySell */
d.addEventListener('click',function(e){
  var t=e.target&&e.target.closest&&e.target.closest('[data-izc-cod]');if(!t)return;
  var b=esBtn();if(!b)return; /* si EasySell no está, se usa el formulario propio del tema */
  e.preventDefault();e.stopImmediatePropagation();
  /* EasySell añade el pack al carrito: se vacía antes para que solo vaya el pack elegido */
  if(t.dataset.izcBusy)return;t.dataset.izcBusy='1';
  fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}}).catch(function(){}).then(function(){delete t.dataset.izcBusy;b.click();});
},true);

var LOGO='<svg viewBox="0 0 48 48" aria-hidden="true"><defs><linearGradient id="izc-lg-es" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#4FC3FF"/><stop offset="1" stop-color="#1268E3"/></linearGradient></defs><polygon points="24,5 40.45,14.5 40.45,33.5 24,43 7.55,33.5 7.55,14.5" fill="url(#izc-lg-es)" stroke="url(#izc-lg-es)" stroke-width="6" stroke-linejoin="round"/><path d="M13.5 22.5c3.6 6.4 17.4 6.4 21 0" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round"/></svg><span class="izc-logo-w"><b>IZECO</b><span>mfort</span><sup class="izc-reg">®</sup></span>';
var SHIELD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>';

function sel(){return $('[data-izc-bundle][aria-checked="true"]');}

function enhance(){
  var b=esBtn();
  if(b){d.documentElement.classList.add('izc-has-es');imp(b,'display','none');}
  var st=d.getElementById('es-sticky');if(st)imp(st,'display','none');
  var m=d.getElementById('easysell-modal');if(!m)return;
  m.classList.add('izc-es');
  var c=d.getElementById('es-form-container');
  if(c){imp(c,'background','transparent');imp(c,'box-shadow','none');imp(c,'border','0');}
  /* Cabecera con logo */
  var h=$('.es-form-header',m);
  if(h&&!$('.izc-es-brand',m)){
    var br=d.createElement('div');br.className='izc-es-brand';
    br.innerHTML='<span class="izc-logo izc-es-logo">'+LOGO+'</span><p class="izc-es-k">Pago contrarreembolso · Envío 24/48 h</p>';
    h.parentNode.insertBefore(br,h);
  }
  var tt=h&&$('.flex-fill strong',h);if(tt&&tt.textContent!=='Completa tus datos y paga al recibirlo')tt.textContent='Completa tus datos y paga al recibirlo';
  /* Precio tachado y ahorro del pack elegido */
  var s=sel(),pr=$('.es-line-item .flex-grow-1',m);
  if(pr&&s){
    var key=s.dataset.variant+'|'+s.dataset.price+'|'+s.dataset.compare,box=$('.izc-es-was',pr);
    if(!box||box.dataset.k!==key){
      if(box)box.remove();
      var p=+s.dataset.price,w=+s.dataset.compare;
      if(w>p){
        box=d.createElement('div');box.className='izc-es-was';box.dataset.k=key;
        box.innerHTML='<s>'+money(w)+'</s><span>Ahorras '+money(w-p)+' · -'+Math.round((w-p)*100/w)+'%</span>';
        pr.appendChild(box);
      }
    }
  }
  /* Botón final en azul */
  var f=d.getElementById('es-form-button');
  if(f){imp(f,'background','linear-gradient(180deg,#2B95F2 0%,#1683E8 50%,#0C5FC6 100%)');imp(f,'border-radius','999px');imp(f,'border-width','0');imp(f,'box-shadow','0 16px 30px -14px rgba(22,131,232,.85), inset 0 1px 0 rgba(255,255,255,.3)');}
  var cta=$('.es-cta-group',m);
  if(cta&&!$('.izc-es-trust',m)){
    var tr=d.createElement('p');tr.className='izc-es-trust';
    tr.innerHTML=SHIELD+'<span>No pagas nada ahora · Pagas al recibirlo · 14 días de devolución</span>';
    cta.parentNode.insertBefore(tr,cta.nextSibling);
  }
}

/* 2. Reseñas: se ven las primeras y el resto con «Ver más opiniones» */
function reviews(){
  var w=$('.izc-rv8-wd');if(!w||w.dataset.izcClamp)return;
  w.dataset.izcClamp='1';w.classList.add('is-clamped');
  var btn=d.createElement('button');btn.type='button';btn.className='izc-rv-more';btn.textContent='Ver más opiniones';
  btn.addEventListener('click',function(){w.classList.remove('is-clamped');btn.remove();});
  w.parentNode.insertBefore(btn,w.nextSibling);
}

function run(){enhance();reviews();}
run();
if('MutationObserver' in window){
  var q=0;new MutationObserver(function(){if(q)return;q=requestAnimationFrame(function(){q=0;run();});}).observe(d.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-checked','style']});
}
})();
